// Bridge objects
import { Ads } from './Bridges/AdsBridge';
import { Data } from './Bridges/DataBridge';
import { Debug } from './Bridges/DebugBridge';
import { Main } from './Bridges/MainBridge';
import { Notifications } from './Bridges/NotificationsBridge';
import { Purchases } from './Bridges/PurchasesBridge';
import { Services } from './Bridges/ServicesBridge';
import { Tracking } from './Bridges/TrackingBridge';

export const Native = {
    ads: Ads,
    data: Data,
    debug: Debug,
    main: Main,
    notifications: Notifications,
    purchases: Purchases,
    services: Services,
    tracking: Tracking,
};

// Bridges functions.
export { callNative, callNativeAsync, registerNative } from './Utility/CallNative';

// Types and interfaces.
export { NativeTrackingEvent } from './Bridges/TrackingBridge';
export { DataEndpoint } from './Bridges/DataBridge';
export { PurchaseConsumeStatus } from './Bridges/PurchasesBridge';
export { PlatformErrorCode, PLATFORM_ERROR_CODES } from './Bridges/ErrorCode';
export { AuthPlatform } from './Bridges/AuthPlatform';
export { IFacebookUser } from './Bridges/ServicesBridge';
export { AdjustAttributionData } from './Bridges/TrackingBridge';
